
import s from './websocket/state'
import * as a from './websocket/actions'
import * as m from './websocket/mutations'
import * as g from './websocket/getters'

export const state = s
export const actions = {...a}
export const mutations = {...m}
export const getters = {...g}
